"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _blExchangeAppointment = require("@/api/blExchangeAppointment/blExchangeAppointment");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _indexSetterDate = _interopRequireDefault(require("./indexSetterDate"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'SearchContainerPh2',
  components: {
    dragDialog: _DragDialog.default,
    Pagination: _Pagination.default,
    indexSetterDate: _indexSetterDate.default
  },
  props: {
    blNo: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      listQuery: {
        currentPage: 1,
        pageSize: 100,
        namedParameters: {}
      },
      total: 0,
      tableData: [],
      poolTypeList: [],
      form: {
        setterDate: ''
      },
      loading: null,
      hotSettings: {
        dragCheck: true,
        height: 'calc(50vh - 215px)',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        fragmentSelection: 'cell',
        copyPaste: false
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    handleSearch: function handleSearch() {
      var _this = this;
      this.loading = (0, _utils.load)();
      (0, _blExchangeAppointment.searchContainer)(this.listQuery).then(function (res) {
        if (res.success) {
          _this.total = res.data.totalRecord;
          _this.listQuery.currentPage = res.data.currentPage;
          _this.listQuery.pageSize = res.data.pageSize;
          // 映射数据，添加 setterDate 并存储原始日期
          _this.tableData = res.data.records.map(function (record) {
            var newRecord = (0, _objectSpread2.default)({}, record);
            newRecord._originalSetterDate = record.setterDate || null; // 存储原始日期
            return newRecord;
          });
        }
      }).catch(function (err) {
        _this.$message.error(err.message || '查询数据失败');
      }).finally(function () {
        _this.loading.close();
      });
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    // 下一步
    handleNext: function handleNext() {
      // 验证日期
      if (!this.validateDates()) return;
      // 准备并保存数据
      this.savePickUpData();
    },
    /**
     * 验证每行的提箱日期是否合法（不早于原始日期）
     * @returns {boolean} 验证结果
     */
    validateDates: function validateDates() {
      var invalidRows = [];
      this.tableData.forEach(function (row, index) {
        // 只有当设置了日期且有原始日期时才进行验证
        if (!row.setterDate || !row._originalSetterDate || row.saveStatus !== '1') return;
        // 转换为日期对象并移除时间部分
        var newDate = new Date(row.setterDate);
        var originalDate = new Date(row._originalSetterDate);
        newDate.setHours(0, 0, 0, 0);
        originalDate.setHours(0, 0, 0, 0);

        // 如果新日期早于原始日期，记录该行
        if (newDate < originalDate) {
          invalidRows.push({
            containerNo: row.containerNo,
            setterDate: row.setterDate,
            originalDate: row._originalSetterDate
          });
        }
      });

      // 如果存在无效行，显示错误信息
      if (invalidRows.length > 0) {
        this.showDateValidationError(invalidRows);
        return false;
      }
      return true;
    },
    /**
     * 显示日期验证错误信息
     * @param {Array} invalidRows 无效行数据
     */
    showDateValidationError: function showDateValidationError(invalidRows) {
      var _this2 = this;
      var errorMessage = this.$t('blExchangeAppointment.infoChangePickupDate') + '\n';
      invalidRows.forEach(function (row) {
        errorMessage += _this2.$t('blExchangeAppointment.infoChangePickupDate', {
          containerNo: row.containerNo,
          setterDate: row.setterDate,
          originalDate: row.originalDate
        });
        errorMessage += '\n';
      });

      // 使用自定义类设置更宽的提示框
      this.$alert(errorMessage, this.$t('blExchangeAppointment.infoChangePickupDateErrorTitle'), {
        confirmButtonText: this.$t('btn.confirm'),
        type: 'warning',
        dangerouslyUseHTMLString: true,
        customClass: 'wider-alert-box'
      });
    },
    /**
     * 准备数据并调用API保存
     */
    savePickUpData: function savePickUpData() {
      var _this3 = this;
      // 创建tableData的深拷贝
      var requestData = (0, _utils.deepClone)(this.tableData);

      // 格式化数据
      requestData.forEach(function (item) {
        if (item.setterDate) {
          // 格式化日期并添加时间
          item.pickUpDate = "".concat(item.setterDate, " 00:00:00");
        } else {
          item.pickUpDate = null;
        }
        // 移除旧字段
        delete item.setterDate;
      });

      // 调用API保存数据
      this.loading = (0, _utils.load)();
      (0, _blExchangeAppointment.doSavePickUpCtnRecord)(requestData).then(function () {
        // 保存成功后进行下一步滞期费计算
        _this3.$emit('handleNextConfirmPrint', _this3.tableData);
      }).catch(function (err) {
        _this3.$message.error('保存提箱记录失败');
      }).finally(function () {
        if (_this3.loading) {
          _this3.loading.close();
          _this3.loading = null;
        }
      });
    },
    opened: function opened() {
      this.listQuery.namedParameters.blNo = this.blNo;
      this.handleSearch();
    },
    handleDatePickerBlur: function handleDatePickerBlur() {
      var _this4 = this;
      this.tableData.forEach(function (item) {
        _this4.$set(item, 'setterDate', _this4.form.setterDate);
      });
      this.$refs.hotTable.resizeTo();
    },
    closed: function closed() {}
  }
};